module.exports = __webpack_public_path__ + "img/wild-rag-deck-06.513608e0.jpeg";